import { createPortal } from 'react-dom';
import css from './index.module.scss';
// import AnnouncementBar from './components/AnnouncementBar';
import MainImg from './components/MainImg';
import CustomizeBundle from './components/CustomizeBundle';
import DetailsPopup from './components/DetailsPopup';
import InstallationPopup from './components/InstallationPopup';
import ShoppingCart from './components/ShoppingCart';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';
// import { getIsAdvancedPurchase } from '@/service/customize-bundle-for-dpu';

const tempAccessory: any[] = [];
export default function CustomizeBundleForDPU() {
    const { useState, useEffect, useRouter, Link, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('customize_bundle_for_dpu');
    const [isClient, setIsClient] = useState(false);

    const [openInstallation, setOpenInstallation] = useState(false);

    const [mainImg, setMainImg] = useState('');
    const OUTPUT_UNIT = 7.2;
    const CAPACITY_UNIT = 6;
    const INPUT_UNIT = 5.6;
    const [output, setOutput] = useState(OUTPUT_UNIT);
    const [capacity, setCapacity] = useState(CAPACITY_UNIT);
    const [input, setInput] = useState(INPUT_UNIT);
    const [details, setDetails] = useState(null);
    // const [isAdvanced, setIsAdvanced] = useState(true);

    const bundle_DPU = {
        id: 'dpu',
        name: t('bundles.dpu'),
        limit: 3,
        min: 1,
        img: '/responsive/picture/common-products/DPU.png',
        details: t('bundles.dpu_details'),
        productId: (() => {
            const LocalMap: any = {
                us: '6964802453577',
                ca: '8006700236954',
            };
            return LocalMap[locale] || LocalMap.us;
        })(),
        variantId: (() => {
            const LocalMap: any = {
                us: '40758830071881',
                ca: '44244774650010',
            };
            return LocalMap[locale] || LocalMap.us;
        })(),
        quantity: 1,
        children: [
            {
                id: 'dpu_battery',
                name: t('bundles.dpu_battery'),
                img: '/responsive/picture/common-products/DPU_Battery.png',
                details: [t('bundles.dpu_battery_details_1'), t('bundles.dpu_battery_details_2'), t('bundles.dpu_battery_details_3')],
                limit: 4,
                delivery: locale === 'us',
                quantity: 0,
                virtualPrice: 3299,
                virtualCondition: [0],
                virtualSites: ['us'],
                productId: (() => {
                    const LocalMap: any = {
                        // us: '6965707112521',
                        us: '6981502206025',
                        ca: '8012436209818',
                    };
                    return LocalMap[locale] || LocalMap.us;
                })(),
                variantId: (() => {
                    const LocalMap: any = {
                        // us: '40758559047753',
                        us: '40832693764169',
                        // ca: '44244769276058',
                        ca: '44960085639322',
                    };
                    return LocalMap[locale] || LocalMap.us;
                })(),
                parantVariantId: (() => {
                    const LocalMap: any = {
                        us: '40758830071881',
                        ca: '44244774650010',
                    };
                    return LocalMap[locale] || LocalMap.us;
                })(),
            },
        ],
    };

    const bundle_SHP2 = {
        id: 'shp2',
        name: t('bundles.shp2'),
        limit: 1,
        img: '/responsive/picture/common-products/smart_home_panel_2.png',
        // details: t('bundles.shp2_details'),
        productId: (() => {
            const LocalMap: any = {
                us: '6964802486345',
                ca: '8006700761242',
            };
            return LocalMap[locale] || LocalMap.us;
        })(),
        variantId: (() => {
            const LocalMap: any = {
                us: '40767883575369',
                ca: '44244781531290',
            };
            return LocalMap[locale] || LocalMap.us;
        })(),
    };

    const accessories: any[] = [
        {
            id: 'ts306A',
            name: t('bundles.ts306A'),
            limit: 1,
            img: '/responsive/picture/common-products/TS306A.png',
            index: 0,
            productId: (() => {
                const LocalMap: any = {
                    us: '6972502114377',
                    ca: '8019137822874',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '40790448308297',
                    // ca: '44286204903578',
                    ca: '44300027855002',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        {
            id: 'tsA510A',
            index: 1,
            name: t('bundles.tsA510A'),
            limit: 1,
            img: '/responsive/picture/common-products/TSA510A.png',
            delivery: locale === 'us',
            productId: (() => {
                const LocalMap: any = {
                    us: '6967984422985',
                    ca: '8012436537498',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '40768128680009',
                    // ca: '44244769702042',
                    ca: '44300030804122',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        // {
        //     id: 'trolley',
        //     name: t('bundles.trolley'),
        //     limit: 1, // 最大额度不超过dpu数量
        //     img: '/responsive/picture/common-products/Trolley.png',
        //     details: t('bundles.trolley_details'),
        //     productId: (() => {
        //         const LocalMap: any = {
        //             us: '6965707407433',
        //             ca: '8012436242586',
        //         };
        //         return LocalMap[locale] || LocalMap.us;
        //     })(),
        //     variantId: (() => {
        //         const LocalMap: any = {
        //             us: '40758559408201',
        //             ca: '44244769308826',
        //         };
        //         return LocalMap[locale] || LocalMap.us;
        //     })(),
        // },
        {
            id: '400w',
            index: 2,
            name: t('bundles.400w'),
            limit: 14, // 14 * dpu数量
            img: '/responsive/picture/common-products/400w.png',
            details: [
                t('bundles.400w_details_1'),
                t('bundles.400w_details_2'),
                t('bundles.400w_details_3'),
                t('bundles.400w_details_4'),
                t('bundles.400w_details_5'),
                t('bundles.400w_details_6'),
            ],
            productId: (() => {
                const LocalMap: any = {
                    us: '6618094960713',
                    ca: '7287920001178',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '39998021697609',
                    ca: '42092770263194',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        {
            id: '50AmpHub',
            index: 3,
            name: t('bundles.50AmpHub'),
            limit: 1,
            img: '/responsive/picture/common-products/Amp_Hub_50.png',
            details: t('bundles.50AmpHub_details'),
            delivery: locale === 'us',
            productId: (() => {
                const LocalMap: any = {
                    us: '6965708128329',
                    ca: '8012436275354',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '40758561144905',
                    // ca: '44244769341594',
                    ca: '44300036636826',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        {
            id: 'power_insight',
            index: 4,
            name: t('bundles.power_insight'),
            limit: 1,
            img: '/responsive/picture/common-products/PowerInsight.png',
            details: [
                t('bundles.power_insight_details_1'),
                t('bundles.power_insight_details_2'),
                t('bundles.power_insight_details_3'),
                t('bundles.power_insight_details_4'),
            ],
            delivery: locale === 'us',
            productId: (() => {
                const LocalMap: any = {
                    us: '6967995105353',
                    ca: '8012436603034',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '40768194904137',
                    // ca: '44244769767578',
                    ca: '44300038766746',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        {
            id: 'EV',
            index: 5,
            name: t('bundles.EV'),
            limit: 1,
            img: '/responsive/picture/common-products/EV_XStream_Adapter.png',
            details: t('bundles.EV_details'),
            delivery: locale === 'us',
            productId: (() => {
                const LocalMap: any = {
                    us: '6965708685385',
                    ca: '8012436308122',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '40758561964105',
                    // ca: '44244769374362',
                    ca: '44300047909018',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        {
            id: 'AC',
            index: 6,
            name: t('bundles.AC'),
            limit: 1,
            img: '/responsive/picture/common-products/AC_Generator_Charging_Adapter.png',
            details: t('bundles.AC_details'),
            delivery: locale === 'us',
            productId: (() => {
                const LocalMap: any = {
                    us: '6967949819977',
                    ca: '8012436340890',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '40767961530441',
                    ca: '44244769407130',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        },
        // {
        //     id: 'PPS',
        //     name: t('bundles.PPS'),
        //     limit: 1,
        //     img: '/responsive/picture/common-products/Dongle_PPS_4G.png',
        //     details: t('bundles.PPS_details'),
        //     productId: (() => {
        //         const LocalMap: any = {
        //             us: '6967981310025',
        //             ca: '8012436471962',
        //         };
        //         return LocalMap[locale] || LocalMap.us;
        //     })(),
        //     variantId: (() => {
        //         const LocalMap: any = {
        //             us: '40768109805641',
        //             ca: '44244769636506',
        //         };
        //         return LocalMap[locale] || LocalMap.us;
        //     })(),
        // },
    ];

    // const bundle_gift_trolley = {
    //     id: 'gift_trolley',
    //     name: t('bundles.gift_trolley'),
    //     img: '/responsive/picture/common-products/Trolley.png',
    //     productId: '6807191879753',
    //     variantId: '40435774980169',
    //     gift: true,
    // };

    // const bundle_gift_metal = {
    //     id: 'gift_metal',
    //     name: t('bundles.gift_metal_tab'),
    //     img: '/responsive/picture/common-products/Fixing_Metal_Tab.png',
    //     productId: '6912243957833',
    //     variantId: '40573938925641',
    //     gift: true,
    // };

    const [bundleDPU, setBundleDPU] = useState(bundle_DPU);
    const [bundleSHP2, setBundleSHP2] = useState(bundle_SHP2);
    const [bundleAccessories, setBundleAccessories] = useState(accessories);
    const [shoppingCarts, setShoppingCarts] = useState([]);
    // const [bundleGiftTrolley, setBundleGiftTrolley] = useState(bundle_gift_trolley);
    // const [bundleGiftMetal, setBundleGiftMetal] = useState(bundle_gift_metal);

    const handleDetails = (obj: any) => {
        setDetails(obj);
    };

    const handleBundleUpdate = (bundle: any) => {
        if (bundle?.id === 'dpu') {
            return setBundleDPU(bundle);
        }
        if (bundle?.id === 'shp2') {
            return setBundleSHP2(bundle);
        }
        const tempArr = JSON.parse(JSON.stringify(bundleAccessories));
        const targetIndex = accessories?.findIndex(
            (accessory: any) => accessory?.variantId === bundle?.variantId && accessory?.productId === bundle?.productId,
        );
        if (targetIndex !== -1) {
            setBundleAccessories([...tempArr?.slice(0, targetIndex), bundle, ...tempArr?.slice(targetIndex + 1)]);
        }
    };

    // // 获取是否前300名购买
    // const getIsAdvanced = async () => {
    //     try {
    //         const res = await getIsAdvancedPurchase(locale);
    //         if (res?.code === '0') {
    //             // setIsAdvanced(res?.data);
    //         } else {
    //             console.error(res?.message);
    //         }
    //     } catch (e) {
    //         console.error(e);
    //     }
    // };

    const doInit = (bundle: any) => {
        const tempBundle = JSON.parse(JSON.stringify(bundle));
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (k >= 0) {
                            tempBundle.children[k].discountPrice = res?.data?.price;
                            tempBundle.children[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                            tempBundle.children[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                            tempBundle.children[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        } else {
                            tempBundle.discountPrice = res?.data?.price;
                            tempBundle.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                            tempBundle.inventory = res?.data?.inventoryQuantity ?? undefined;
                            tempBundle.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                            if (bundle?.id === 'shp2') {
                                return setBundleSHP2(tempBundle);
                            }
                            if (bundle?.id !== 'dpu' && !tempAccessory?.find((accessory: any) => accessory?.variantId === tempBundle?.variantId)) {
                                tempAccessory[tempBundle?.index] = tempBundle;
                                if (tempAccessory?.length === accessories?.length && tempAccessory?.every((item: any) => item?.link_buy)) {
                                    return setBundleAccessories(tempAccessory);
                                }
                            }
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        if (bundle?.productId && bundle?.variantId && !bundle?.link_buy) {
            if (!bundle?.children?.length) {
                getAsynItem(bundle?.productId, bundle?.variantId, -1);
                return;
            }
            if (bundle?.children?.length > 0) {
                const tempArr = [{ productId: bundle?.productId, variantId: bundle?.variantId }, ...bundle?.children];
                const promises = tempArr.map((item: any, k: number) => {
                    if (item?.productId && item?.variantId) {
                        getAsynItem(item?.productId, item?.variantId, k === 0 ? -1 : k - 1);
                    }
                });
                return Promise.all(promises)
                    .then(() => {
                        // updateBundle(tempBundle);
                        if (bundle?.id === 'dpu') {
                            return setBundleDPU(tempBundle);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
        }
    };

    useEffect(() => {
        doInit(bundle_DPU);
        doInit(bundle_SHP2);
        accessories?.map((accessory: any) => doInit(accessory));
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        // 主图变化
        setMainImg(`/responsive/picture/common-products/${bundleSHP2?.quantity > 0 ? 'dpu+shp2' : 'delta_pro_ultra'}.png`);
    }, [bundleSHP2]);

    useEffect(() => {
        // outup 变化逻辑
        let outputTemp: number = Math.round(OUTPUT_UNIT * 100 * (bundleDPU?.quantity || 0)) / 100;
        const AMP_HUB = bundleAccessories?.find((accessory: any) => accessory?.id === '50AmpHub');
        if (bundleDPU?.quantity === 2 && AMP_HUB?.quantity > 0) {
            outputTemp = 12;
        }
        setOutput(outputTemp);
    }, [bundleDPU, bundleAccessories]);

    useEffect(() => {
        // solar input 变化逻辑
        setInput(Math.round((bundleDPU?.quantity || 0) * 100 * INPUT_UNIT) / 100);
        // capacity 变化逻辑
        const target = bundleDPU?.children?.find((child: any) => child?.id === 'dpu_battery');
        setCapacity(Math.round(CAPACITY_UNIT * 100 * ((bundleDPU?.quantity || 0) + (target?.quantity || 0))) / 100);
    }, [bundleDPU]);

    useEffect(() => {
        // const trolleyIdx = bundleAccessories?.findIndex((accessory: any) => accessory?.id === 'trolley');
        const sp400wIdx = bundleAccessories?.findIndex((accessory: any) => accessory?.id === '400w');

        if (sp400wIdx !== -1) {
            const sp400w = bundleAccessories[sp400wIdx];
            const newSp400wObj = JSON.parse(JSON.stringify(sp400w));
            if (sp400w?.limit !== bundleDPU?.quantity * 14) {
                newSp400wObj.limit = bundleDPU?.quantity * 14;
            }
            if (sp400w?.quantity > bundleDPU?.quantity * 14) {
                newSp400wObj.quantity = bundleDPU?.quantity * 14;
            }
            setBundleAccessories([...bundleAccessories?.slice(0, sp400wIdx), newSp400wObj, ...bundleAccessories?.slice(sp400wIdx + 1)]);
        }
        // if (trolleyIdx !== -1 && sp400wIdx !== -1) {
        //     // trolley的变化逻辑
        //     const trolley = bundleAccessories[trolleyIdx];
        //     const newTrolleyObj = JSON.parse(JSON.stringify(trolley));
        //     if (trolley?.limit !== bundleDPU?.quantity) {
        //         newTrolleyObj.limit = bundleDPU?.quantity;
        //     }
        //     if (trolley?.quantity > bundleDPU?.quantity) {
        //         newTrolleyObj.quantity = bundleDPU?.quantity;
        //     }
        //     // 400w的变化逻辑
        //     const sp400w = bundleAccessories[sp400wIdx];
        //     const newSp400wObj = JSON.parse(JSON.stringify(sp400w));
        //     if (sp400w?.limit !== bundleDPU?.quantity * 14) {
        //         newSp400wObj.limit = bundleDPU?.quantity * 14;
        //     }
        //     if (sp400w?.quantity > bundleDPU?.quantity * 14) {
        //         newSp400wObj.quantity = bundleDPU?.quantity * 14;
        //     }

        //     // 顺序
        //     if (trolleyIdx < sp400wIdx) {
        //         setBundleAccessories([
        //             ...bundleAccessories?.slice(0, trolleyIdx),
        //             newTrolleyObj,
        //             ...bundleAccessories?.slice(trolleyIdx + 1, sp400wIdx),
        //             newSp400wObj,
        //             ...bundleAccessories?.slice(sp400wIdx + 1),
        //         ]);
        //     } else {
        //         setBundleAccessories([
        //             ...bundleAccessories?.slice(0, sp400wIdx),
        //             newTrolleyObj,
        //             ...bundleAccessories?.slice(sp400wIdx + 1, trolleyIdx),
        //             newSp400wObj,
        //             ...bundleAccessories?.slice(trolleyIdx + 1),
        //         ]);
        //     }
        // }
    }, [bundleDPU]);

    // // 购物车赠送礼品逻辑
    // useEffect(() => {
    //     // EcoFlow Fixing Metal Tab
    //     const DPUBattery = bundleDPU?.children?.find((child: any) => child?.id === 'dpu_battery');
    //     if (DPUBattery) {
    //         const tempGiftMetal = JSON.parse(JSON.stringify(bundleGiftMetal));
    //         if (DPUBattery?.quantity === 2) {
    //             tempGiftMetal.quantity = 1;
    //         } else if (DPUBattery?.quantity < 2) {
    //             tempGiftMetal.quantity = 0;
    //         } else {
    //             tempGiftMetal.quantity = 1 + Math.floor((DPUBattery?.quantity - 2) / 3);
    //         }
    //         setBundleGiftMetal(tempGiftMetal);
    //     }
    // }, [bundleDPU]);

    // useEffect(() => {
    //     getIsAdvanced();
    // }, []);

    // useEffect(() => {
    //     const tempGiftTrolley = JSON.parse(JSON.stringify(bundleGiftTrolley));
    //     tempGiftTrolley.quantity = isAdvanced ? 1 : 0;
    //     setBundleGiftTrolley(tempGiftTrolley);
    // }, [isAdvanced]);

    // 购物车逻辑
    useEffect(() => {
        const tempCarts = [];
        const commonLogic = (bundle: any) => {
            if (bundle?.quantity > 0) {
                tempCarts.push(bundle);
            }
        };
        const ALL_BUNDLES = JSON.parse(
            // JSON.stringify([{ ...bundleDPU }, { ...bundleSHP2 }, ...bundleAccessories, { ...bundleGiftTrolley }, { ...bundleGiftMetal }]),
            JSON.stringify([{ ...bundleDPU }, { ...bundleSHP2 }, ...bundleAccessories]),
        );
        ALL_BUNDLES?.map((bundle: any) => {
            commonLogic(bundle);
            if (bundle?.children?.length > 0) {
                bundle?.children?.map((child: any) => commonLogic(child));
            }
        });
        setShoppingCarts(tempCarts);
    }, [bundleDPU, bundleSHP2, bundleAccessories]);

    // useEffect(() => {
    //     const getAsynItem = async (productId: string, variantId: string, id: string) => {
    //         return await new Promise(async (resolve, reject) => {
    //             const tempBundle = JSON.parse(
    //                 JSON.stringify(id === bundle_gift_trolley?.id ? bundleGiftTrolley : id === bundle_gift_metal?.id ? bundleGiftMetal : {}),
    //             );
    //             try {
    //                 const res = await getSolarRecommand({ productId, variantId }, locale);
    //                 if (res?.code === '0') {
    //                     tempBundle.discountPrice = res?.data?.price;
    //                     tempBundle.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
    //                     tempBundle.inventory = res?.data?.inventoryQuantity ?? undefined;
    //                     tempBundle.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
    //                     if (id === bundle_gift_trolley?.id) {
    //                         setBundleGiftTrolley(isAdvanced ? { ...tempBundle, quantity: 1 } : tempBundle);
    //                     }
    //                     if (id === bundle_gift_metal?.id) {
    //                         setBundleGiftMetal(tempBundle);
    //                     }
    //                     return resolve(res);
    //                 } else {
    //                     console.error(res?.message);
    //                     return reject(res?.message);
    //                 }
    //             } catch (e) {
    //                 console.error(e);
    //                 return reject(e);
    //             }
    //         });
    //     };
    //     getAsynItem(bundle_gift_trolley?.productId, bundle_gift_trolley?.variantId, bundle_gift_trolley?.id);
    //     getAsynItem(bundle_gift_metal?.productId, bundle_gift_metal?.variantId, bundle_gift_metal?.id);
    // }, [isAdvanced]);

    return (
        <div className={`customize-bundle-for-dpu ${css['customize-bundle-for-dpu']}`}>
            {/* <AnnouncementBar /> */}
            <div className="customize-content">
                <MainImg img={mainImg} alt={t('product_title')} />
                <div className="customize-content-product">
                    <h2 className="customize-title">{t('main_product.title')}</h2>
                    <p className="customize-desc">{t('main_product.desc')}</p>
                    <ul className="power-boards">
                        <li className="power-board">
                            <p className="power-number">
                                {output}
                                {t('main_product.unit_kw')}
                            </p>
                            <p className="power-text">{t('main_product.output')}</p>
                        </li>
                        <li className="power-board">
                            <p className="power-number">
                                {capacity}
                                {t('main_product.unit_kwh')}
                            </p>
                            <p className="power-text">{t('main_product.capacity')}</p>
                        </li>
                        <li className="power-board">
                            <p className="power-number">
                                {input}
                                {t('main_product.unit_kw')}
                            </p>
                            <p className="power-text">{t('main_product.input')}</p>
                        </li>
                    </ul>
                    <div className="bundle-common dpu">
                        <CustomizeBundle bundle={bundleDPU} callDetails={handleDetails} updateBundle={handleBundleUpdate} />
                    </div>
                    <div className="bundle-common shp2">
                        <CustomizeBundle
                            bundle={bundleSHP2}
                            callDetails={handleDetails}
                            updateBundle={handleBundleUpdate}
                            callInstallation={setOpenInstallation}
                        />
                    </div>
                    <div className="bundle-accessories-box">
                        <p className="bundle-accessories-title">{t('bundles.title')}</p>
                        <ul className="bundle-accessories">
                            {bundleAccessories.map((accessory: any, _k: number) => (
                                <li className="bundle-accessory bundle-common" key={`${accessory?.id}_${accessory?.limit}_${accessory?.quantity}`}>
                                    <CustomizeBundle bundle={accessory} callDetails={handleDetails} updateBundle={handleBundleUpdate} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            {isClient && details && createPortal(<DetailsPopup details={details} callDetails={handleDetails} />, document.body)}
            {isClient && openInstallation && createPortal(<InstallationPopup callInstallation={setOpenInstallation} />, document.body)}
            {isClient && createPortal(<ShoppingCart carts={shoppingCarts} updateBundle={handleBundleUpdate} />, document.body)}
        </div>
    );
}
